<template>
  <div>
    <new-sancion-read
      :dataPartido="{}"
      :dataSancion="dataSancion"
      :listMotivos="[]"
    ></new-sancion-read>
    <b-card no-body class="p-1">
      <b-overlay :show="showLoading" rounded="sm">
        <b-table
          ref="refInvoiceListTable"
          :fields="tableColumns"
          :items="listSancionados"
          primary-key="id"
          show-empty
          responsive
          small
          empty-text="No se encontraron datos"
          class="position-relative"
          style="max-height:60vh"
          :sticky-header="true"
          :no-border-collapse="true"
        >
          <!-- Column: Player -->
          <template #cell(jugador)="data">
            <b-media vertical-align="center">
              <template #aside>
                <div style="display:grid">
                  <b-avatar
                    size="32"
                    :src="data.item.foto_jug"
                    :text="avatarText(data.item.nombres)"
                  />
                </div>
              </template>
              <span class="font-weight-bold d-block text-nowrap">
                ({{ data.item.num_camiseta }}) {{ data.item.apellido }}
                {{ data.item.nombre }}
              </span>
              <div class="text-muted small">{{ data.item.ci_pasaporte }}</div>
              <small class="text-muted">{{ data.item.categoria }}</small>
              <div class="text-muted text-uppercase small" style="">
                {{ data.item.equipo }}
              </div>
            </b-media>
          </template>
          <template #cell(sancion)="data">
            <b-media vertical-align="center">
              <span class="font-weight-bold d-block text-nowrap">
                E:{{ data.item.etapa }} | F:{{ data.item.num_fecha }} -
                {{ data.item.local }} vs {{ data.item.visita }}
              </span>
              <div class="text-muted small" style="">
                jugado el {{ data.item.fecha_par }}
              </div>
              <div
                @click="getDetalleSancion(data.item)"
                style="text-decoration:underline;cursor:pointer;font-size:10px;color:blue"
              >
                Ver detalle
              </div>
            </b-media>
          </template>
          <template #cell(sancion_data)="data">
            <b-media vertical-align="center">
              <!-- <span class="font-weight-bold d-block text-nowrap">
                Inicia sancion: Etapa {{ data.item.etapa_inicio_sancion }} fecha
                {{ data.item.inicio_sancion }}
              </span> -->
              <div class="text-muted small" style="">
                Duración: {{ data.item.duracion_sancion }}
              </div>
              <div class="text-muted small" style="">
                Pendientes: {{ data.item.duracion }}
              </div>
            </b-media>
          </template>
          <template #cell(etapa)="data">
            <div class="text-center">
              {{ data.item.etapa_buscar }}
            </div>
          </template>
          <template #cell(aplicada)="data">
            <template>
              <b-badge
                pill
                :variant="data.item.estado === 'n' ? 'success' : 'danger'"
              >
                {{ data.item.estado == 'n' ? `Actualizada` : 'Pendiente' }}
              </b-badge>
              <div class="text-muted small">
                {{
                  data.item.estado == 'n' ? `${data.item.fecha_aplicacion}` : ''
                }}
              </div>
              <div class="text-muted small">
                {{
                  data.item.estado == 'n'
                    ? `Por: ${data.item.nombre_usuario}`
                    : ''
                }}
              </div>
            </template>
          </template>
          <template #cell(opc)="data">
            <div class="text-nowrap">
              <feather-icon
                v-if="USER().rol === ROLES.SUPER"
                icon="XIcon"
                class="cursor-pointer"
                size="16"
                @click="deletePendiente(data.item)"
              />
            </div>
          </template>
        </b-table>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BOverlay,
  BTable,
  BMedia,
  BAvatar,
  BBadge,
  // BButton,
  VBTooltip,
  // BModal,
  // BCardText,
  // BSpinner,
  //   BIconLayers,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import apiCall from '../../utils/apiCall'
import NewSancionRead from './DetalleSancionRead.vue'

import {
  URL,
  USER,
  ROLES,
  // INSERT_DATA_PLAYER,
  // INSERT_DATA_HISTORY_PLAYER,
  // UPDATE_DATA_PLAYER,
  // ESTADO_JUGADOR,
} from '../../utils/variables'
// import modalLog from './LogDetalle.vue'

export default {
  components: {
    BCard,
    BOverlay,
    BTable,
    BMedia,
    BAvatar,
    BBadge,
    NewSancionRead,
    // BButton,
    // BModal,
    // BCardText,
    // BSpinner,
    // modalLog,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  props: {
    listSancionados: Array,
    showLoading: Boolean,
  },
  setup(props, { emit }) {
    // const showLoading = ref(false)
    const tableColumns = [
      { key: 'id_sancion_pendiente', label: 'id', sortable: true },
      { key: 'jugador', sortable: true },
      { key: 'sancion', label: 'sancionado en', sortable: true },
      { key: 'sancion_data', sortable: true },
      { key: 'etapa', label: 'Act en etapa' },
      { key: 'aplicada', label: 'Aplicada' },
      { key: 'opc' },
      // { key: 'estado_jug', sortable: true },
    ]
    const { postApi, getApi } = apiCall()
    // const listSancionados = ref([])
    const dataLog = ref(null)
    const showEliminarEspecial = ref(false)
    const showLoadingEliminar = ref(false)
    const sancionElegida = ref(null)
    const dataSancion = ref({})
    function getDetalle(item) {
      // console.log(props)
      emit('getDetalleEspecial', item)
      store.commit('someVariables/UPDATE_SHOW_NEW_SANCION', true)
    }
    function showNewSancionOnly() {
      emit('onlyEspecial')
    }
    async function deletePendiente(item) {
      const path = 'ApiSanciones/deletePendiente'
      const data = {
        id_sancion_pendiente: item.id_sancion_pendiente,
      }
      const response = await postApi(URL, path, data)
      if (response.flag === 'si') {
        emit('delete')
      }
    }
    // function verDetalle(item) {
    //   dataSancion.value = item
    //   store.commit('someVariables/UPDATE_SHOW_NEW_SANCION_READ', true)
    // }
    async function getDetalleSancion(item) {
      // store.commit('someVariables/UPDATE_SHOW_NEW_SANCION_READ', true)
      const path = `ApiSanciones/getSancionIdTarjetaRel/${item.id_tarjeta_rel}/${item.idEquipo}`
      const data = await getApi(URL, path)
      // console.log(data.data)
      // console.log(item)
      // item.duracion = data.data.duracion
      // item.motivo = data.data.motS
      item.listPartidos = data.detalle
      item.tipo = data.data.tipo
      item.fecha_incio_sancion = data.data.fecha_incio_sancion
      item.fecha_fin_especial = data.data.fecha_fin_especial
      item.rangeSancion = `${data.data.fecha_incio_sancion} to ${data.data.fecha_fin_especial}`
      item.duracionEspecial = data.data.diferencia
      item.id_sancion = data.data.id_sancion
      item.inicio_auxiliar = data.data.inicio_auxiliar
      item.fin_auxiliar = data.data.fin_auxiliar
      item.motivo_auxiliar = data.data.motivo_auxiliar
      item.detalle = data.data.detalleArt
      item.userAplica = data.data.userAplica
      item.id_auditoria = data.data.id_auditoria
      item.fecha_mod = data.data.fecha_mod
      item.id_motivo_sancion_ant = data.data.id_motivo_sancion_ant
      // item.duracion_ant = data.data.duracion_ant
      item.motivo_ant = data.data.motSAnt
      item.num_pendientes = data.data.num_pendientes
      item.detalle_partidos = data.detalle
      item.id_campeonato = data.data.id_campeonato

      dataSancion.value = { ...item }
      store.commit('someVariables/UPDATE_SHOW_NEW_SANCION_READ', true)

      // ci_pasaporte
    }
    // const { getApi } = apiCall()
    // async function getEspeciales(idTorneo) {
    //   listSancionados.value = []
    //   showLoading.value = true
    //   const path = `ApiSanciones/getSancionesEspeciales/${idTorneo}`
    //   const data = await getApi(URL, path)
    //   listSancionados.value = data.data
    //   showLoading.value = false
    // }
    // onMounted(() => {
    //   getEspeciales(
    //     // eslint-disable-next-line
    //     store.getters['someVariables/getTorneoSeleccionado'].id_torneo
    //   )
    //   // console.log(refP.value)
    // })
    function showModalLog(item) {
      dataLog.value = item
      store.commit('someVariables/UPDATE_SHOW_MODAL_LOG', true)
    }
    function showModalConfirmacion(item) {
      showEliminarEspecial.value = true
      sancionElegida.value = item
      // console.log(sancionElegida.value)
    }
    async function deleteEspecial() {
      showLoadingEliminar.value = true
      const path = 'ApiSanciones/deleteSancionEspecial'
      const data = {
        idSancion: sancionElegida.value.id_sancion,
        idUsuario: USER().id_usuario,
        idTorneo:
          store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
        dataMovimiento: `Elimina la sanción especial del jugador/a ${sancionElegida.value.apellidos} ${sancionElegida.value.nombres} sancionado
        desde ${sancionElegida.value.inicio_auxiliar} hasta ${sancionElegida.value.fin_auxiliar}`,
      }
      const response = await postApi(URL, path, data)
      if (response.flag === 'si') {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'SANCION ELIMINADA exitosamente',
              icon: 'AlertCircleIcon',
              variant: 'success',
              solid: true,
            },
          },
          {
            position: 'top-bottom',
            // eslint-disable-next-line
          }
        )
        emit('recargaEspeciales')
        showEliminarEspecial.value = false
        // insertMultasTarjetasAutomatico()
      }
      showLoadingEliminar.value = false
    }

    return {
      // showLoading,
      tableColumns,
      // listSancionados,
      showModalLog,
      // modalLog,
      dataLog,
      avatarText,
      getDetalle,
      showNewSancionOnly,
      ROLES,
      USER,
      showEliminarEspecial,
      showLoadingEliminar,
      showModalConfirmacion,
      deleteEspecial,
      deletePendiente,
      // verDetalle,
      dataSancion,
      getDetalleSancion,
    }
  },
}
</script>
